import { useState } from "react";
import toast from "react-hot-toast";

import { useGlobalStates } from "../../utlis/ClubsContext";
import { ErrorMessage } from "../../utlis/function";
import { callApi } from "../../services/ApiServices";
import CommonLoader from "../common/CommonLoader";
import TipTapEditor from "./TipTapEditor";

/* ---------- Helpers ---------- */
const stripHtml = (html = "") => html.replace(/<[^>]*>?/gm, "").trim();

/* ---------- Component ---------- */
const AddClubTermsMediaForm = ({
  formData,
  updateFormData,
  errors,
  setErrors,
  activeStep,
  steps,
  handleNext,
  setCompletedStep,
  completedStep,
}) => {
  const { clubId } = useGlobalStates();
  const [isLoading, setIsLoading] = useState(false);

  /* ---------- Validation ---------- */
  const validateAllFields = () => {
    const error = !stripHtml(formData.termsAndConditions)
      ? "Terms & conditions are required"
      : "";

    setErrors({ termsAndConditions: error });
    return !error;
  };

  const stripHtmlTags = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  /* ---------- API ---------- */
  const saveFormData = async () => {
    setIsLoading(true);
    const plainTextTerms = stripHtmlTags(formData.termsAndConditions);
    try {
      return await callApi({
        method: "put",
        url: `club/terms/${clubId}`,
        data: {
          terms: plainTextTerms,
        },
      });
    } catch (error) {
      console.log("failed to save Terms", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  /* ---------- Handlers ---------- */
  const handleSaveWithAPI = async () => {
    if (!validateAllFields()) return;

    const response = await saveFormData();
    if (response?.status === 200) {
      toast.success("Terms saved successfully");
      setCompletedStep(4);
      handleNext();
    }
  };

  const handleNextWithAPI = async () => {
    if (completedStep === 4) return handleNext();
    if (!validateAllFields()) return;

    const response = await saveFormData();
    if (response?.status === 200) {
      setCompletedStep(4);
      handleNext();
    }
  };

  /* ---------- UI ---------- */
  return (
    <div className="space-y-6">
      {isLoading && <CommonLoader fullScreen />}

      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-medium text-black mb-2">
          Terms & Conditions
        </h2>
        <p className="text-base text-textcolor mb-6">
          Define the policies, ad guidelines, and booking rules that advertisers
          must follow for campaigns at this venue.
        </p>

        {/* Single Editor */}
        <TipTapEditor
          value={formData.termsAndConditions}
          onChange={(html) => updateFormData({ termsAndConditions: html })}
        />

        {/* Error */}
        {errors?.termsAndConditions && (
          <div className="mt-2">
            <ErrorMessage message={errors.termsAndConditions} />
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between mt-6">
        <button
          onClick={handleSaveWithAPI}
          disabled={isLoading}
          className="px-2 h-[60px] w-[200px] border border-primary text-primary font-medium text-lg rounded-full"
        >
          Save
        </button>

        <button
          onClick={handleNextWithAPI}
          disabled={isLoading}
          className="px-2 h-[60px] w-[200px] bg-primary hover:bg-hover text-white rounded-full font-medium text-lg"
        >
          {activeStep === steps.length - 1 ? "Submit" : "Next"}
        </button>
      </div>
    </div>
  );
};

export default AddClubTermsMediaForm;
